<template>
   <v-app>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="login-part d-flex align-center justify-center">
          <v-row no-gutters>
            <v-col
              cols="12"
              class="login-part d-flex align-center justify-center flex-column"
            >
              <div class="login-wrapper dark">
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-container>
                    <v-row class="flex-column text-right">
                      <v-col>
                        <v-text-field
                          label="New Password"
                          outlined
                          hide-details="auto"
                          class="mb-0"
                          v-model="pass1"
                        ></v-text-field>
                      </v-col>
                      <v-col>
                        <v-text-field
                          label="Confirm New Password"
                          outlined
                          hide-details="auto"
                          class="mb-0"
                          v-model="pass2"
                        ></v-text-field>
                      </v-col>
                      <v-col class="d-flex justify-space-between">
                        <v-btn
                          class="text-capitalize flex-grow-1 mr-3"
                          large
                          color="primary"
                          @click="resetOldPassword()"
                        >
                          Kirim</v-btn
                        >
                        <v-btn
                          class="text-capitalize flex-grow-1"
                          large
                          text
                          color="primary"
                          to="/"
                        >
                          Kembali Ke Login</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
            <v-col>
              <v-dialog
                v-model="showTokenExpired"
                persistent
                max-width="450"
                max-height="350"
                width="100%"
              >
                <v-card class="pa-3">
                  <div class="d-flex align-center justify-center mb-2">
                    <v-img
                      max-height="40"
                      max-width="40"
                      src="@/assets/alert.jpg"
                    ></v-img>
                  </div>
                  <v-card-text class="text-center font-weight-bold">
                    {{ this.showMessage }}
                  </v-card-text>
                  <v-card-text class="text-center">
                  <v-spacer></v-spacer>
                  <v-btn
                    outlined
                    class="text-capitalize ml-2"
                    small
                    text
                    color="black"
                    @click="toLogin()"
                  >
                    Login
                  </v-btn>
                </v-card-text>
                </v-card>
              </v-dialog>
            </v-col>
            <v-col>
              <v-dialog
                v-model="showDialogUnmatch"
                persistent
                max-width="450"
                max-height="350"
                width="100%"
              >
                <v-card class="pa-3">
                  <div class="d-flex align-center justify-center mb-2">
                    <v-img
                      max-height="40"
                      max-width="40"
                      src="@/assets/alert.jpg"
                    ></v-img>
                  </div>
                  <v-card-text class="text-center font-weight-bold">
                    Password dan Confirm Password tidak sesuai
                  </v-card-text>
                  <v-card-text class="text-center">
                  <v-spacer></v-spacer>
                  <v-btn
                    outlined
                    class="text-capitalize ml-2"
                    small
                    text
                    color="black"
                    @click="showDialogUnmatch = false"
                  >
                    Ok
                  </v-btn>
                </v-card-text>
                </v-card>
              </v-dialog>
            </v-col>
            <v-col>
              <v-dialog
                v-model="showDialogSucceded"
                persistent
                max-width="450"
                max-height="350"
                width="100%"
              >
                <v-card class="pa-3">
                  <div class="d-flex align-center justify-center mb-2">
                    <v-img
                      max-height="40"
                      max-width="40"
                      src="@/assets/check-green.png"
                    ></v-img>
                  </div>
                  <v-card-text class="text-center font-weight-bold">
                    Password berhasil di ubah
                  </v-card-text>
                  <v-card-text class="text-center">
                    <v-spacer></v-spacer>
                    <v-btn
                      outlined
                      class="text-capitalize ml-2"
                      small
                      text
                      color="black"
                      @click="toLogin"
                    >
                      Login
                    </v-btn>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
    </v-container>
    <v-snackbar v-model="showSnackbar" :color="snackbarColor">
      {{ snackbarMsg }}
      <template v-slot:action="{ attrs }">
        <v-btn text small v-bind="attrs" @click="showSnackbar = false">
          X
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapActions } from "vuex";


export default {
  
  name: "NewPassword",
  // props: ['email','token'],
  data(){
    return {
      showMessage: '',
      showTokenExpired: false,
      showDialogSucceded: false,
      valid: true,
      userType: localStorage.getItem("login__selectedUserType"),
      pass1: '',
      pass2: '',
      showDialogUnmatch: false,
      newPassword: '',
      usernameRules: [
        (v) => !!v || "NIK harus diisi",
        (v) => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail harus valid'
        // v => v.length >= 6 || 'Min 6 characters'
      ],
    }
  },
  methods: {
    ...mapActions(["forgotPass", "refreshToken", "validateForgotPassword","resetPassword"]),

    validateToken(){
      this.validateForgotPassword({
        email: this.$route.query.email,
        token: this.$route.query.token
      })
      .then((response) => {
        console.log(response)
        if (response.data.status == 0) {
          this.showMessage = response.data.message;
          this.showTokenExpired = true;
        }
      })
    },

    toLogin(){
      this.$router.push({name: 'login'});
    },

    resetOldPassword(){
      if (this.pass1 !== this.pass2) {
        this.showDialogUnmatch = true;
      } else {
        this.newPassword = this.pass1;
        this.resetPassword({
          email: this.$route.query.email,
          newPassword: this.newPassword,
          token: this.$route.query.token
        })
        .then((response) => {
          console.log(response)
          this.showDialogSucceded = true;
        })
      }
      
    }
  },
  computed:{
    showSnackbar: {
      get: function () {
        return this.$store.getters.showSnackbar;
      },
      set: function () {
        this.$store.commit("hideSnackBar");
      },
    },
    snackbarMsg: {
      get: function () {
        return this.$store.getters.snackbarMsg;
      },
      set: function () {
        this.$store.commit("resetSnackBarMsg");
      },
    },
    snackbarColor: {
      get: function () {
        return this.$store.getters.snackbarColor;
      },
      set: function () {
        this.$store.commit("resetSnackBarColor");
      },
    },
  },
  mounted(){
    this.validateToken();
    console.log('email: '+this.$route.query.email);
    // console.log('token: '+this.token);
  }
}
</script>

<style src="../Login/Login.scss" lang="scss"/>